document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".premium-form")) return;
  const LDCalendaringObjName = "LDCalendaring";

  // Get the form type from data attr
  const formType = document.querySelector("#hbspt-demo-form").dataset.type;
  const formId = getFormId(formType);
  const sfdcCampaignId = getCampaignId(formType);

  // Embed the form in the html
  hbspt.forms.create({
    region: "na1",
    portalId: "43974469",
    formId: formId,
    sfdcCampaignId: sfdcCampaignId,
    target: "#hbspt-demo-form",
    onFormReady: function (form) {
      // form[0] is the form html element
      submitHandlerRegister("hsFormReadyCallback", form[0]);
      normalizeForm(form[0]);
      new window.NRIForm(`#${form[0].id}`, formType);

      const algoliaCheck = setInterval(() => {
        const autocompleteElement = document.querySelector('[name="company"]');
        const listbox = document.querySelector(
          "#nri-input-menu-listbox---school-or-district-name"
        );
        const state = document.querySelector('[name="state_region"]');
        if (autocompleteElement && listbox && state) {
          clearInterval(algoliaCheck);
          new window.Algolia(
            '[name="company"]',
            "#nri-input-menu-listbox---school-or-district-name",
            '[name="state_region"]'
          );
        }
      }, 1);
    },
    onFormSubmit: function (form) {
      // calendar link
      if (localStorage.getItem("LDCalendaring_hubspot_calendarLink")) {
        const calendarLinkInput = form[0].querySelector(
          'input[name="ld_bookit_calendar_link"]'
        );
        calendarLinkInput.value = localStorage.getItem(
          "LDCalendaring_hubspot_calendarLink"
        );
        calendarLinkInput.dispatchEvent(new Event("change", { bubbles: true }));
      }

      // /form input
      if (localStorage.getItem("LDCalendaring_hubspot_formInput")) {
        const formInput = JSON.parse(
          localStorage.getItem("LDCalendaring_hubspot_formInput")
        );
        const ldLogID = formInput.LD_BookIt_Log_ID__c;
        const logIDInput = form[0].querySelector(
          'input[name="ld_bookit_log_id__c"]'
        );
        logIDInput.value = ldLogID;
        logIDInput.dispatchEvent(new Event("change", { bubbles: true }));
      }

      // grade checkboxes
      const gradeCheckboxes = form[0].querySelectorAll(
        'input[name="grades__c"]'
      );
      gradeCheckboxes[0].value = "Grades 3-5";
    },
  });

  const orgId = "00D41000002GZayEAG";
  const nodeName = "Premium App HubSpot";

  // Set up Leandata
  (function (windowRef, documentRef, fileLocation, functionName) {
    windowRef["LeanDataCalendaringObjName"] = functionName;
    windowRef[functionName] = (...args) => {
      windowRef[functionName].variables = args;
    };
    const scriptElement = documentRef.createElement("script");
    const targetScript = document.getElementsByTagName("script")[0];
    const targetHead = document.getElementsByTagName("head")[0];
    scriptElement.async = 1;
    scriptElement.src = fileLocation;
    if (targetScript && targetScript.parentNode) {
      targetScript.parentNode.insertBefore(scriptElement, targetScript);
    } else if (targetHead) {
      targetHead.append(scriptElement);
    }
  })(
    window,
    document,
    "https://app.leandata.com/js-snippet/ld_calendaring.js",
    "LDCalendaring"
  );

  LDCalendaring(orgId, nodeName, true, {
    popupModalOn: false,
  });

  function submitHandlerRegister(fName, form) {
    if (
      window[LDCalendaringObjName] &&
      window[LDCalendaringObjName][fName] &&
      form
    ) {
      window[LDCalendaringObjName][fName](
        form,
        form.getAttribute("data-form-id")
      );
    } else {
      setTimeout(() => {
        submitHandlerRegister(fName, form);
      }, 1000);
    }
  }
});

/**
 *  @param {HTMLFormElement} element
 *  @description - Adds aria rules and classes so the hubspot form integrates with the Form class
 */
function normalizeForm(element) {
  const elementInputs = element.querySelectorAll(".hs-form-field");

  const mainField = document.createElement("div");
  mainField.className = "main-field";
  const legalConsent = element.querySelector(".legal-consent-container");

  elementInputs.forEach((elementInput) => {
    const lastChild = elementInput.children.length - 1;

    const input = elementInput.children.item(lastChild);
    if (!input) return;

    const field = input.children.item(0);
    if (!field) return;

    const fieldName = field.getAttribute("name");

    switch (fieldName) {
      case "role__c":
        addHomeschoolingOption(field);
        break;
      case "company":
        addSchoolDropdown(field);
        break;
      default:
        if (elementInput.classList.contains("hs-grades__c")) {
          addFieldsetCheckboxesId(field);
        }
        mainField.append(elementInput);
        break;
    }
  });

  element.insertBefore(mainField, legalConsent);

  // School/district needs to get moved from where it is in the original form
  mainField.insertBefore(
    element.querySelector(".hs-company"),
    element.querySelector(".hs-grades__c")
  );

  // Insert the homeschool error for school after the field
  const homeSchoolError = document.querySelector(".homeschool-error");
  mainField.insertBefore(
    homeSchoolError,
    element.querySelector(".hs-grades__c")
  );

  // Add non-input elements to the main-field class to handle the role error
  legalConsent.classList.add("main-field");
  // const recaptcha = element.querySelector('.hs_recaptcha');
  // recaptcha.classList.add('main-field');

  // add required fields and validation messages
  Array.from(document.querySelectorAll(".hs-form-field")).forEach((element) => {
    if (element.style.display != "none") {
      const input = element.querySelector(".hs-input");
      if (input) {
        if (input.type != "checkbox") {
          input.setAttribute("aria-required", true);
          input.dataset.errorMessageId = input.id + "-tip";
          switch (input.name) {
            case "role__c":
              input.dataset.errorMessage = "Please select a role.";
              break;
            case "pa_enrollment_range__c":
              input.dataset.errorMessage = "Please select an enrollment range.";
              break;
            case "firstname":
              input.dataset.errorMessage = "Please enter your first name.";
              break;
            case "lastname":
              input.dataset.errorMessage = "Please enter your last name.";
              break;
            case "email":
              input.dataset.errorMessage =
                "Please enter a valid email address.";
              break;
            case "phone":
              input.dataset.errorMessage = "Please enter a valid phone number.";
              break;
            case "state_region":
              input.dataset.errorMessage = "Please select your state.";
              break;
            case "company":
              input.dataset.errorMessage = "Please enter your school/district.";
              break;
            default:
              input.dataset.errorMessage =
                "Please complete the required field.";
              break;
          }
        } else {
          element.querySelector(".inputs-list").dataset.errorMessageId =
            input.id + "-tip";
          element.querySelector(".inputs-list").dataset.errorMessage =
            "Please select at least one grade.";
        }
      }
    }
  });

  // add main-field class to submit button
  const submitWrap = element.querySelector(".hs-submit");
  submitWrap.classList.add("main-field");

  // create false submit button to use when form is invalid
  const submitBtn = submitWrap.querySelector('input[type="submit"]');
  const falseSubmit = submitBtn.cloneNode(true);
  falseSubmit.classList.add("false-submit");
  falseSubmit.type = "button";
  submitBtn.after(falseSubmit);
}

function addHomeschoolingOption(field) {
  const option = document.createElement("option");
  option.id = "id-nri-select--PARENT_OR_HOMESCHOOLING";
  option.value = "PARENT_OR_HOMESCHOOLING";
  option.textContent = "I’m a parent, home school, or micro school teacher";
  field.append(option);
}

function addSchoolDropdown(field) {
  const dropdown = document.createElement("ul");
  dropdown.id = "nri-input-menu-listbox---school-or-district-name";
  dropdown.setAttribute("role", "listbox");
  field.after(dropdown);
}

function addFieldsetCheckboxesId(field) {
  field.id = "premium-application-grades";
}

function getFormId(type) {
  switch (type) {
    case "demo":
      return "364d3910-a1d4-40dd-8a63-2da81da24851";
    case "premium":
      return "74b8ad65-7cd0-4827-bca5-b67396914eec";
    default:
      return "";
  }
}
function getCampaignId(type) {
  switch (type) {
    case "demo":
      return "701Qj000001dc9hIAA";
    case "premium":
      return "7011K000001ionQQAQ";
    default:
      return "";
  }
}
